import { render } from "./BlStandaloneField.vue?vue&type=template&id=1bfb9316&scoped=true"
import script from "./BlStandaloneField.vue?vue&type=script&lang=js"
export * from "./BlStandaloneField.vue?vue&type=script&lang=js"

import "./BlStandaloneField.vue?vue&type=style&index=0&id=1bfb9316&scoped=true&lang=scss"

import exportComponent from "/tmp/5e119732-5ebd-42f7-baa8-4916aa59fc29/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfb9316"]])

export default __exports__